/**
 * Secure pages only shown if the user is authenticated
 * @see {@link https://auth0.com/docs/quickstart/spa/vuejs#secure-the-profile-page | Auth0}
 */
import { authGuard } from '@/plugins/authGuard'

const Start = () => import(/* webpackChunkName: "home" */ '../views/Start.vue')
const About = () => import(/* webpackChunkName: "about" */ '../views/About.vue')
const Userinfo = () => import(/* webpackChunkName: "userinfo" */ '../views/Userinfo.vue')
const MainContainer = () => import(/* webpackChunkName: "main-container" */ '../views/MainContainer.vue')
const Cashier = () => import(/* webpackChunkName: "cashier" */ '../views/Cashier.vue')
const CashierConfirmation = () => import(/* webpackChunkName: "cashier-confirmation" */ '../views/CashierConfirmation.vue')
const CashierCancel = () => import(/* webpackChunkName: "cashier-cancel" */ '../views/CashierCancel.vue')
const CashierDone = () => import(/* webpackChunkName: "cashier-done" */ '../views/CashierDone.vue')
const SmartLock = () => import(/* webpackChunkName: "smart-lock" */ '../views/SmartLock.vue')
const StoreLive = () => import(/* webpackChunkName: "smart-lock" */ '../views/StoreLive.vue')
const AppNotes = () => import(/* webpackChunkName: "smart-lock" */ '../views/AppNotes.vue')

export default [
	{
		path: '/start',
		name: 'start',
		component: Start
	},
	{
		path: '/about',
		name: 'About',
		component: About
	},
	// {
	// 	path: '/userinfo',
	// 	name: 'Userinfo',
	// 	component: Userinfo,
	// 	beforeEnter: authGuard
	// },
	{
		path: '/main',
		name: 'MainContainer',
		component: MainContainer,
		beforeEnter: authGuard,
		redirect: '/main/cashier',
		children: [
			{
				path: 'cashier',
				name: 'Cashier',
				component: Cashier,
				children: [
					{
						path: 'confirmation',
						name: 'CashierConfirmation',
						component: CashierConfirmation
					},
					{
						path: 'cancel',
						name: 'CashierCancel',
						component: CashierCancel
					},
					{
						path: 'done/:transaction_id',
						name: 'CashierDone',
						component: CashierDone
					}
				]
			},
			{
				path: 'userinfo',
				name: 'Userinfo',
				component: Userinfo
			},
			{
				path: 'smartLock',
				name: 'SmartLock',
				component: SmartLock
			},
			{
				path: 'storeLive',
				name: 'StoreLive',
				component: StoreLive
			}
		]
	},
	{
		path: '/notes',
		name: 'appNotes',
		component: AppNotes
	},
	{
		path: '/',
		redirect: '/start'
	},
	{
		path: '*',
		redirect: '/start'
	}
]
